import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import InvestmentKnowledge from 'Components/Universal/Questionnaire/Sections/InvestmentKnowledge';

const InvestmentKnowledgeAssessmentSectionPicker = ({ clientResource, ...rest }) => {
  return pickFunction(clientResource, {
    [fr.relationships.default.name]: () => <InvestmentKnowledge {...rest} />,
  });
};

export default InvestmentKnowledgeAssessmentSectionPicker;
